import { useState } from "react";
import GraficaCategorias from "../components/GraficaCategorias";
import GraficaGastosPorMes from "../components/GraficaGastosPorMes";
import GraficaIngresosVsGastos from "../components/GraficaIngresosVsGastos";
import ResumenMensual from "../components/ResumenMensual";
import Layout from "../layout/Layout";

export default function Dashboard() {
  const [mes, setMes] = useState(() => {
    const hoy = new Date();
    return `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, "0")}`;
  });

  return (
    <Layout>
        <div className="container text-center">
          <div className="row">
            <div className="col">
              <ResumenMensual mes={mes} setMes={setMes} />
            </div>
            <div className="col">
              <GraficaCategorias mes={mes} />
            </div>
            <div className="col">
              <GraficaGastosPorMes mes={mes} />
            </div>
            <div className="col">
              <GraficaIngresosVsGastos mes={mes} />
            </div>
          </div>
        </div>
    </Layout>
  );
}
